import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ToggleSwitch from "../../extras/ToggleSwitch";
import CouponDialogue from "./CouponDialogue";
import Title from "../../extras/Title";
import Button from "../../extras/Button";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import Table from "../../extras/Table";
import Pagination from "../../extras/Pagination";
import { useEffect } from "react";
import {
  activeCoupon,
  deleteCoupon,
  getCoupon,
} from "../../../redux/slice/couponSlice";
import { warning } from "../../../util/Alert";
import { IconPlus, IconTrash } from "@tabler/icons-react";

const Coupon = () => {
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [page, setPage] = useState(0);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const { setting } = useSelector((state) => state?.setting);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const { coupon, isLoading } = useSelector((state) => state.coupon);

  useEffect(() => {
    dispatch(getCoupon());
  }, [dispatch]);

  useEffect(() => {
    setData(coupon);
  }, [coupon]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const couponTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Title",
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.title}</span>
      ),
    },
    {
      Header: "Code",
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.code}</span>
      ),
    },
    {
      Header: "Description",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.description}</span>
      ),
    },
    {
      Header: "Discount (%)",
      Cell: ({ row }) => (
        <span className="text-capitalize">
          {row?.discountPercent ? row?.discountPercent : "Not Applicable"}
        </span>
      ),
    },
    {
      Header: `Minimum Amount To Apply (${setting?.currencySymbol || "$"})`,
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.minAmountToApply}</span>
      ),
    },
    {
      Header: "Maximum Discount",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row?.maxDiscount}</span>
      ),
    },
    {
      Header: "isActive",
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isActive}
          onClick={() => handleStatus(row?._id)}
        />
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
        <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleDelete(row?._id)}
          >
            <IconTrash className="text-secondary" />
          </button>
        </div>
      ),
    },
  ];

  const handleDelete = (couponId) => {
    // if (!hasPermission) return permissionError();
    const data = warning("Delete");
    data
      .then((logouts) => {
        const yes = logouts.isConfirmed;
        // console.log("yes", yes);
        if (yes) {
          dispatch(deleteCoupon(couponId));
        }
      })
      .catch((err) => console.log(err));
  };

  const handleStatus = (couponId) => {
    // if (!hasPermission) return permissionError();

    dispatch(activeCoupon(couponId));
  };
  return (
    <>
      {dialogueType === "coupon" && <CouponDialogue />}
      <div className="userPage">
        <div className="user-table mb-3">
          <div className="user-table-top">
            <div className=" d-flex justify-content-between align-items-center w-100 ">
              <div className="w-100">
                <h5
                  className="main-title">
                  Coupons
                </h5>
              </div>
              <div className="d-flex gap-2 justify-content-end w-100">
                  <Button
                bIcon={<IconPlus size={18}/>}
                text="Add coupon"
                onClick={() => {
                  dispatch(openDialog({ type: "coupon" }));
                }}
              />
              </div>
            </div>
          </div>

          {/* <Title name="Coupons" /> */}
          
          
            <Table
              type={"client"}
              data={data}
              mapData={couponTable}
              PerPage={rowsPerPage}
              Page={page}
            />
            <Pagination
              type={"client"}
              serverPage={page}
              setServerPage={setPage}
              serverPerPage={rowsPerPage}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              totalData={data?.length}
            />
         
        </div>

      </div>
    </>
  );
};

export default Coupon;
